import { BACKEND_URL } from '@/core/config';
import { server } from '../core/server/axios';

export interface ChangeKursKzVariables {
	depId: string | number,
	buy: number,
	sell: number,
	buyRub: number,
	sellRub: number,
	buyEur: number,
	sellEur: number,
}

export class ParsingController {
	async loadMigRates(): Promise<any> {
		return await server.get('/Parsing/migparse', {
			baseURL: BACKEND_URL
		});
	}

	async loadBccRates(): Promise<any> {
		return await server.get('/Parsing/bck', {
			baseURL: BACKEND_URL
		});
	}

	async loadYesRates(): Promise<any> {
		return await server.get('/Parsing/yes', {
			baseURL: BACKEND_URL
		});
	}

	async loadNationalGoldRate(): Promise<any> {
		return await server.get('/Parsing/goldParse', {
			baseURL: BACKEND_URL
		});
	}

	async loadNationalRates(): Promise<any> {
		return await server.get('/NB/xrates', {
			baseURL: BACKEND_URL
		});
	}

	async loadKaseUsdRate(): Promise<{ rate: number; rateSource: string; updateDate: string; updateTime: string; }> {
		return await server.get('/Parsing/kase', {
			baseURL: BACKEND_URL
		});
	}

	async changeKursKz({ depId, buy, sell, buyRub, sellRub, buyEur, sellEur }: ChangeKursKzVariables): Promise<any> {
		return await server.post('/KursAutoPoster/update',
			{
				depId,
				buy,
				sell,
				buyRub,
				sellRub,
				buyEur,
				sellEur
			},
			{
				baseURL: BACKEND_URL
			});
	}

	async changeKursKzMany(kursKzRates: ChangeKursKzVariables[]): Promise<any> {
		return await server.post('/KursAutoPoster/updateMany',
			kursKzRates,
			{
				baseURL: BACKEND_URL
			});
	}

	async getKursKz(): Promise<any> {
		return await server.get('/KursAutoPoster/getList',
			{
				baseURL: BACKEND_URL
			});
	}
}